<template>
    <Modal @modal:dismiss="$emit('dismiss')" class="purple-theme">
        <div slot="header">
            <div class="text-center">
                <font-awesome-icon icon="sign-out-alt" class="fa-5x purple-theme" />
            </div>
            <h3><slot name="header" /></h3>
        </div>

        <div slot="body">
            <div class="form-control text-center"><slot name="body" /></div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch purple-theme" @click="$emit('dismiss')">
                    Annuler
                </CustomButton>
                <CustomButton class="stretch default purple-theme" @click="$emit('close')">
                    Valider
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal';
import CustomButton from '@/components/Button';

export default {
    props: ['value'],
    data() {
        return {};
    },
    components: {
        Modal,
        CustomButton,
    },
};
</script>

<style lang="scss">
.text-center {
    text-align: center;
    margin-bottom: 22px;
}

svg.purple-theme {
    color: #6c3e91;
}
</style>
